import React, { useState } from "react";
import PropTypes from "prop-types";
import Manager from "./Manager";
import Search from "./Search";
import Button from "../Button";
import styles from "./style.module.scss";
import { Link } from "gatsby";

export default function CampusManagers({ managers }) {
  const [search, setSearch] = useState("");

  function getManagers() {
    return managers.filter(manager => manager.university.includes(search));
  }

  function sortUniversitiesByName(universities) {
    const compare = (a, b) => {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      // names must be equal
      return 0;
    };

    universities.sort((a, b) => {
      const nameA = a.toUpperCase(); // ignore upper and lowercase
      const nameB = b.toUpperCase();
      return compare(nameA, nameB);
    });
    return universities;
  }

  function getUniversities() {
    const universities = [];
    managers.map(manager => {
      if (!universities.includes(manager.university)) {
        universities.push(manager.university);
      }
    });

    return sortUniversitiesByName(universities);
  }

  function createManager(manager) {
    return (
      <div className={styles.manager}>
        <Manager
          key={`${manager.firstName} ${manager.lastName}`}
          manager={manager}
        />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <h1>Dedicated Entrepreneurs</h1>
        <p>
          Allow us to introduce the team that makes it all happen. Each of our
          campus managers boasts an impressive track record. Whether it be a
          killer GPA or the reigning title for best dance moves, these are the
          people who make connections with organizations, create custom
          garments, and deliver killer products!
        </p>
        <div className={styles.button}>
          <Link to="/apply" key="apply">
            <Button>We're Hiring!</Button>
          </Link>
        </div>
      </div>
      <div className={styles.managersContainer}>
        <div className={styles.filters}>
          <Search
            universities={getUniversities()}
            onChange={val => setSearch(val)}
          />
        </div>
        {getManagers().map(manager => createManager(manager))}
        <div className={styles.footer}>
          Greek Dressing would not be where it is today if it were not for the
          incredible contributions from our Campus Managers. Interested in
          joining the team?{" "}
          <Link to="/apply" key="apply">
            Apply here.
          </Link>
        </div>
      </div>
    </div>
  );
}

CampusManagers.propTypes = {
  managers: PropTypes.arrayOf(PropTypes.shape).isRequired
};
